import React, {useState} from 'react'

import BusinessIcon from '@mui/icons-material/Business';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import MultipleStopIcon from '@mui/icons-material/MultipleStop';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';

import './Sidebar.css'
import { NavLink as Link } from "react-router-dom";
import ColorLensIcon from '@mui/icons-material/ColorLens';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import  CompanySelection  from  "../../shared/companyselection/CompanySelection";
import LockIcon from '@mui/icons-material/Lock';
import axios from 'axios';

const Sidebar = () => {

  const [userRole, setUserRole] = useState(localStorage.getItem("userrole"));
  const [openState, setOpenState] = useState(false);

  const[usercompanylogo, setUserCompanyLogo] = useState(localStorage.getItem("usercompanylogo"));
  const[usercompanyname, setUserCompanyName] = useState(localStorage.getItem("usercompanyname"));

  const changeCompany=()=>{
    if(userRole == "Admin"){
        setOpenState(true);
    }
  }

  return (
    <div className="sidebar">
      { openState == true && <CompanySelection setOpenState={setOpenState} open={openState}/> }
      <div className="top" onClick={changeCompany}>
          <img src={axios.defaults.baseURL + "/" + usercompanylogo} className="logo" title={usercompanyname} /> <span className="company-name">{usercompanyname}</span> { userRole == "Admin" && <MoreVertIcon className="icon float-right"/> } 
      </div>
      <div className="center">
        <ul>
          <p className="title">Main</p>
          {/* <li><Link to="/" className={({ isActive }) => isActive ? "active": ""}><DashboardIcon className="icon"/> <span>Dashboard</span></Link></li> */}
          <li><Link to="/" className={({ isActive }) => isActive ? "active": ""}><AssessmentIcon className="icon"/> <span>Assessments</span></Link></li>
          <p className="title">Manage</p>
          { userRole == "Admin" ? <li><Link to="/behavioralclusters" className={({ isActive }) => isActive ? "active": ""}><ColorLensIcon className="icon"/> <span>Behavioral Clusters</span></Link></li> : "" }
          { userRole == "Admin" ? <li><Link to="/behaviors" className={({ isActive }) => isActive ? "active": ""}><EmojiEmotionsIcon className="icon"/> <span>Behaviors</span></Link></li> : "" }
          { userRole == "Admin" ? <li><Link to="/situations" className={({ isActive }) => isActive ? "active": ""}><MultipleStopIcon className="icon"/> <span>Situations</span></Link></li> : "" }
          { userRole == "Admin" ? <li><Link to="/companies" className={({ isActive }) => isActive ? "active": ""}><BusinessIcon className="icon"/> <span>Companies</span></Link></li> : "" }
          <li><Link to="/users" className={({ isActive }) => isActive ? "active": ""}><SettingsAccessibilityIcon className="icon"/> <span>Users</span></Link></li>
          <li><Link to="/training" className={({ isActive }) => isActive ? "active": ""}><ModelTrainingIcon className="icon"/> <span>Training</span></Link></li>
          <li><Link to="/changepassword" className={({ isActive }) => isActive ? "active": ""}><LockIcon className="icon"/> <span>Change Password</span></Link></li>
          { userRole == "Admin" ? <p className="title">Assessment</p> : "" }
          { userRole == "Admin" ? <li><Link to="/editor" className={({ isActive }) => isActive ? "active": ""}><SummarizeIcon className="icon"/> <span>Report Editor</span></Link></li> : "" }
        </ul>
      </div>
      <div className="bottom">
        
      </div>
    </div>
  )
}

export default Sidebar